import React from "react";

function Product({ item, ...props }) {
  const {
    trackId,
    trackName,
    artworkUrl100,
    trackPrice,
    longDescription,
    artistName,
  } = item;
  return (
    <div className="product">
      <img className="artwork" src={artworkUrl100} alt="album art" />
      <div className="info">
        <h2>{trackName ? trackName.substring(0, 80)+ "...": "" }</h2>
        <h3>{artistName ? artistName : ""}</h3>
        <p className="price">
          {trackPrice ? `£${trackPrice}` : "no price available"}
        </p>
        <p className="description">
          {longDescription ? longDescription.substring(0, 300) + "..." : ""}
        </p>
      </div>
      <div className="buttons">
        {item.inBasket ? (
          <button
            className="remove-button"
            onClick={() => props.removeFromBasket(trackId)}
          >
            <img
              alt="cross icon"
              className="icon"
              src="icons/remove.png"
            />
          </button>
        ) : (
          <button
            className="add-button"
            onClick={() => props.addToBasket(trackId)}
          >
            <img
              alt="add to basket icon"
              className="icon"
              src="icons/add-basket.png"
            />
          </button>
        )}
      </div>
    </div>
  );
}

export default Product;